import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import CardFeed from 'buyside/components/presentation/CardFeed/cardFeed';
import ContestPrizes from 'buyside/components/presentation/ContestShowPage/ContestPrizes/contestPrizes';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';

import { contestUrl } from 'buyside/util/urlHelper';

import styles from 'buyside/components/presentation/ContestIndexPage/ContestIndexCard/contestIndexCardStyles.scss';

const ContestIndexCard = ({ contest: { id, name, startDate, endDate, promoSummary, prizes } }) => (
  <CardFeed type="secondary" className={styles.contestCard}>
    <div className={styles.contestCardHeader}>
      <FontAwesomeIcon className={styles.trophyIcon} icon={faTrophy} />
      <div>
        <div className={styles.contestTitle}>{name}</div>
        <div className={styles.contestDate}>
          {startDate} - {endDate}
        </div>
      </div>
    </div>
    <ParsedHtml html={promoSummary}>{({ content }) => <p>{content}</p>}</ParsedHtml>
    <Button text={'View ' + name} type={BUTTON_TYPES.PRIMARY} url={contestUrl(id)} />
    {prizes.length > 0 ? (
      <>
        <h4 className={styles.prizeHeading}>Prizes</h4>
        <ContestPrizes prizes={prizes} />
      </>
    ) : null}
  </CardFeed>
);

export default ContestIndexCard;
